import { POSITION_LABEL_GAP_PX } from "./positionConstants";

const overlapsHorizontally = (first, second) =>
  first.x < second.x + second.width && second.x < first.x + first.width;

const overlaps = (first, second) =>
  overlapsHorizontally(first, second) &&
  first.y < second.y + second.height + POSITION_LABEL_GAP_PX &&
  second.y < first.y + first.height + POSITION_LABEL_GAP_PX;

/**
 * Moves labels apart vertically so none of them overlap: from the top down
 * each label goes under the ones it would cover; labels pushed past the
 * bottom edge are then moved back up above the ones under them. Fixed
 * rectangles (the last price badge) stay where they are, the labels go round them.
 * Several positions on one pair get their cards one under another.
 *
 * @param {Array<{ rect: { x: number, y: number, width: number, height: number } }>} labels -
 *   rect.y is changed in place
 * @param {number} bottom - lowest edge for labels, CSS px
 * @param {Array<{ x: number, y: number, width: number, height: number }>} [fixedRects]
 */
export const stackLabels = (labels, bottom, fixedRects = []) => {
  const placed = fixedRects.map((rect) => ({ rect, isFixed: true }));

  [...labels]
    .sort((first, second) => first.rect.y - second.rect.y)
    .forEach((label) => {
      const { rect } = label;
      let isMoved = true;

      while (isMoved) {
        isMoved = false;

        for (let index = 0; index < placed.length; index += 1) {
          const other = placed[index].rect;

          if (overlaps(rect, other)) {
            rect.y = other.y + other.height + POSITION_LABEL_GAP_PX;
            isMoved = true;
          }
        }
      }

      placed.push(label);
    });

  placed.sort((first, second) => first.rect.y - second.rect.y);

  for (let index = placed.length - 1; index >= 0; index -= 1) {
    const { rect, isFixed } = placed[index];
    let maxBottom = bottom;

    for (let next = index + 1; next < placed.length; next += 1) {
      const other = placed[next].rect;

      if (overlapsHorizontally(rect, other)) {
        maxBottom = Math.min(maxBottom, other.y - POSITION_LABEL_GAP_PX);
      }
    }

    if (!isFixed) rect.y = Math.min(rect.y, maxBottom - rect.height);
  }
};
